import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import envconfig from './envconfig';
import { getCacheVal, isTokenCloseToExpiration } from '../services/utils';

const httpLink = createHttpLink({
  uri: envconfig.apolloClientAddress,
});

const authLink = setContext((_, { headers }) => {
  const token = getCacheVal('token');
  token && isTokenCloseToExpiration(token);

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
    },
  },
});
